import IvrNode from './IvrNode';
import generateId from 'src/lib/generateId';
import { IsNotEmpty, IsString, ValidateNested, IsNumber, IsOptional } from 'class-validator';
import { IsStringPropertyUniqueInStoreSlice } from 'src/actions/validators/IsStringPropertyUniqueInStoreSlice';
import { IVR_TAGS } from 'src/models/Thread/Thread';
import { Type } from 'class-transformer';

export type IvrNodeMap = { [id: string]: IvrNode };
export default class Ivr {
  createdAt?: string;
  createdBy?: string;
  debug?: boolean;
  description?: string;
  id: string;

  @IsString()
  @IsNotEmpty()
  @IsStringPropertyUniqueInStoreSlice('ivrs', { message: 'IVR with this name already exists' })
  name: string;

  @IsString()
  comment: string;

  @ValidateNested({ each: true })
  @Type(() => IvrNode)
  nodes?: IvrNode[];

  publishedAt?: string;
  publishedBy?: string;

  rootNodeId?: string;

  @IsOptional()
  tags?: IVR_TAGS[];

  @IsNumber()
  @IsNotEmpty()
  version: number;

  archivedAt?: string;
}

export const DefaultIvrConfiguration: Ivr = Object.freeze({
  comment: 'create ivr',
  id: generateId(),
  name: '',
  nodes: [],
  version: 1,
  tags: [IVR_TAGS.TELEPHONY],
});
